import { recipe } from "@vanilla-extract/recipes";

import { transition } from "../../utils/transition";

export const iconStyle = recipe({
  base: {
    transition: transition("transform"),
  },
  variants: {
    state: {
      open: {
        transform: "rotate(-90deg)",
      },
      closed: {
        transform: "rotate(90deg)",
      },
      default: {},
    },
  },
  defaultVariants: {
    state: "default",
  },
});
